/**
 * Helpers for polling GET /content/bulk-generate/{parentJobId}/ (bulk job status).
 */

import type { ApiError } from './client';

/** API `code` from envelope: {@link ErrorCodes.BULK_JOB_STATUS_UNAVAILABLE} on backend */
export const ERROR_BULK_JOB_STATUS_UNAVAILABLE = 9009;
/** API `code` when parent job id is unknown; may occur briefly before children are visible. */
export const ERROR_BULK_JOB_NOT_FOUND = 3013;

export function shouldAbortBulkJobPollingImmediately(err: unknown): boolean {
  const e = err as Partial<ApiError>;
  const s = e.status;
  return s === 401 || s === 403;
}

/**
 * Errors where the client should keep polling (up to a small consecutive limit).
 */
export function isTransientBulkJobPollError(err: unknown): boolean {
  if (shouldAbortBulkJobPollingImmediately(err)) {
    return false;
  }
  const e = err as Partial<ApiError>;
  const code = e.errorCode;
  if (code === ERROR_BULK_JOB_STATUS_UNAVAILABLE) {
    return true;
  }
  if (code === ERROR_BULK_JOB_NOT_FOUND) {
    return true;
  }
  if (e.code === 'TIMEOUT') {
    return true;
  }
  const s = e.status ?? 0;
  if (s >= 500 && s <= 599) {
    return true;
  }
  if (s === 408 || s === 429 || s === 502 || s === 503 || s === 504) {
    return true;
  }
  if (!s) {
    return true;
  }
  return false;
}
